export const features = {
  notifications: true,
  supervisors: true,
  student: false,
  payment: true,
};

//standard=> not have{ notification,supervisors}
//basic=>not have{ notification,supervisors,student,payment}
